import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2.5",
      d: "M16 22.033h.02m8.98 0h.02m8.98 0h.02M15 37.065v4.682c0 1.068 0 1.602.219 1.876.19.239.478.377.782.377.35 0 .766-.334 1.598-1.001l4.771-3.825c.975-.782 1.462-1.172 2.005-1.45a6 6 0 0 1 1.523-.536c.597-.123 1.221-.123 2.47-.123H33.4c3.36 0 5.04 0 6.324-.655a6 6 0 0 0 2.622-2.628c.654-1.286.654-2.97.654-6.337V16.62c0-3.368 0-5.051-.654-6.338a6 6 0 0 0-2.622-2.628C38.44 7 36.76 7 33.4 7H16.6c-3.36 0-5.04 0-6.324.655a6 6 0 0 0-2.622 2.628C7 11.57 7 13.253 7 16.621v12.427c0 1.864 0 2.796.204 3.56a6 6 0 0 0 4.243 4.253c.763.205 1.693.205 3.553.205m2-15.032a1.001 1.001 0 1 1-2.002.002A1.001 1.001 0 0 1 17 22.033m9 0a1.001 1.001 0 1 1-2.002.002A1.001 1.001 0 0 1 26 22.033m9 0a1.001 1.001 0 1 1-2.002.002A1.001 1.001 0 0 1 35 22.033"
    }, null, -1)
  ])))
}
export default { render: render }